module.exports = __webpack_public_path__ + "img/score-2.00a35b18.png";